import { render } from "./CustomerAccount.vue?vue&type=template&id=4008928d"
import script from "./CustomerAccount.vue?vue&type=script&lang=js"
export * from "./CustomerAccount.vue?vue&type=script&lang=js"

import "./CustomerAccount.vue?vue&type=style&index=0&id=4008928d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__